import React from 'react';
import { Link } from 'react-router-dom';

const SpeakerEmptyState = ({ hasFilters, onClearFilters }) => {
  return (
    <div className="text-center py-16 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700">
      <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
        <svg className="w-8 h-8 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      {hasFilters ? (
        <>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
            No speakers matched your search.
          </h3>
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-4">
            Try removing a filter or searching by another ministry topic.
          </p>
          <button
            onClick={onClearFilters}
            className="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary-dark transition-colors"
          >
            Clear Filters
          </button>
        </>
      ) : (
        <>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
            No speakers available yet.
          </h3>
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-4">
            Speaker profiles will appear here once they are added.
          </p>
          <Link
            to="/speakers/apply"
            className="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary-dark transition-colors"
          >
            Create Speaker Profile
          </Link>
        </>
      )}
    </div>
  );
};

export default SpeakerEmptyState;
